import { selectRouterPathname } from '@noths/polaris-client-next-redux';
import { build } from '@noths/polaris-product-listings-urls';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { push, replace } from 'connected-next-router';

import { buildListingsURL } from 'src/adapters/storeToPageURL/builders/buildListingsURL';
import { buildListingsQueryParams } from 'src/adapters/storeToPageURL/state/buildListingsQueryParams';
import {
  buildListingsURLFromState,
  facetsToSelections,
} from 'src/adapters/storeToPageURL/state/buildListingsURLFromState';
import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import { extractBasePath } from 'src/utils/extractBasePath';

interface UpdatePageURLWithQueryOptions {
  history?: 'push' | 'replace';
}

export const updatePageURLWithQuery = createAsyncThunk<void, UpdatePageURLWithQueryOptions | void>(
  'products/updatePageURLWithQuery',
  async (options, { dispatch, getState }) => {
    const { history = 'push' } = options ?? {};
    const state = getState() as ReduxApplicationState;
    const { pathname } = state.router.location;
    const routerPathname = selectRouterPathname(state);
    const { page, taxonomyAttributeAliases = [] } = state.productsQuery;

    if (taxonomyAttributeAliases.length > 0) {
      const url = buildListingsURLFromState(state);
      dispatch((history === 'push' ? push : replace)(url, url, { shallow: true, scroll: false }));
      return;
    }

    const urlParams = buildListingsQueryParams(state, { page });
    const filters = facetsToSelections(state.productsQuery.facets ?? []);
    // Non-taxonomy routes carry no taxonomy levels, so every active facet is a
    // filter. `href` uses the Next route pattern, `as` the displayed path.
    const href = buildListingsURL(
      build({ basePath: extractBasePath(routerPathname), filters, taxonomyAliases: [] }),
      urlParams,
      state.navigation.hash,
    );
    const as = buildListingsURL(
      build({ basePath: extractBasePath(pathname), filters, taxonomyAliases: [] }),
      urlParams,
      state.navigation.hash,
    );

    dispatch((history === 'push' ? push : replace)(href, as, { shallow: true, scroll: false }));
  },
);
